export default __webpack_public_path__ + "static/media/mq-new-5.5cf35750.jpg";